import { connect } from 'react-redux';
import DndDragLayer from '../components/dnd-drag-layer';

const mapStateToProps = state => ({
  view: state.gantt.view,
  dateReference: state.gantt.dateReference,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DndDragLayer);
